document.addEventListener('DOMContentLoaded', function () {
  const select = document.getElementById('cityFilter');
  const coupons = document.querySelectorAll('.CouponsList__single');

  select.addEventListener('change', function () {
      const selected = this.value;

      coupons.forEach(coupon => {
          const cities = coupon.dataset.cities.split(',');
          if (selected && cities.includes(selected)) {
              coupon.classList.add('active');
          } else {
              coupon.classList.remove('active');
          }
      });
  });
});
